'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cn } from '#lib/utils';
const Drawer = t0 => {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      shouldScaleBackground: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const shouldScaleBackground = t1 === undefined ? true : t1;
  let t2;
  if ($[3] !== props || $[4] !== shouldScaleBackground) {
    t2 = <DrawerPrimitive.Root shouldScaleBackground={shouldScaleBackground} {...props} />;
    $[3] = props;
    $[4] = shouldScaleBackground;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
Drawer.displayName = 'Drawer';
const DrawerTrigger = DrawerPrimitive.Trigger;
const DrawerPortal = DrawerPrimitive.Portal;
const DrawerClose = DrawerPrimitive.Close;
const DrawerOverlay = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Overlay>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("fixed inset-0 z-[60] bg-black/80", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <DrawerPrimitive.Overlay ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
const DrawerContent = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Content>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
}>((t0, ref) => {
  const $ = _c(19);
  let children;
  let className;
  let overlayClassName;
  let overlayStyle;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      overlayClassName,
      overlayStyle,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = overlayClassName;
    $[4] = overlayStyle;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    overlayClassName = $[3];
    overlayStyle = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== overlayClassName || $[7] !== overlayStyle) {
    t1 = <DrawerOverlay className={overlayClassName} style={overlayStyle} />;
    $[6] = overlayClassName;
    $[7] = overlayStyle;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== className) {
    t2 = cn("fixed inset-x-0 bottom-0 z-[60] flex h-auto flex-col bg-background", className);
    $[9] = className;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== props || $[13] !== ref || $[14] !== t2) {
    t3 = <DrawerPrimitive.Content ref={ref} className={t2} {...props}>{children}</DrawerPrimitive.Content>;
    $[11] = children;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t3) {
    t4 = <DrawerPortal>{t1}{t3}</DrawerPortal>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
});
DrawerContent.displayName = 'DrawerContent';
const DrawerHeader = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("grid gap-1.5 p-4 text-center sm:text-left", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
DrawerHeader.displayName = 'DrawerHeader';
const DrawerFooter = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mt-auto flex flex-col gap-2 p-4", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
DrawerFooter.displayName = 'DrawerFooter';
const DrawerTitle = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Title>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-lg font-semibold leading-none tracking-tight", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <DrawerPrimitive.Title ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;
const DrawerDescription = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Description>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Description>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-sm text-muted-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <DrawerPrimitive.Description ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
DrawerDescription.displayName = DrawerPrimitive.Description.displayName;
const DrawerNested = DrawerPrimitive.NestedRoot;
export { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerNested, DrawerOverlay, DrawerPortal, DrawerTitle, DrawerTrigger };